import React from "react";
import { useHistory } from "react-router";
import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Button } from "Components/Button";
import { createToast } from "Utils/toastFunc";
import { useMutation } from "react-query";
import {
  createProductRule,
  ProductRulesFormValues,
} from "Requests/ProductsRules";
import * as S from "../Partners/styles";
import { ProductRulesForm } from "./ProductRulesForm";

export const ProductRules = () => {
  const createProductRuleMutation = useMutation({
    mutationFn: createProductRule,
    onSuccess: () => {
      createToast("success", "Regras salvas com sucesso");
      history.push("/regras/regras-produtos/lista");
    },
    onError: (errors: string[]) => {
      errors.forEach((error: string) => createToast("error", error));
    },
  });

  const history = useHistory();

  const handleSubmit = async (values: ProductRulesFormValues) => {
    const payload = {
      product_id: values.product?.id ? values.product?.id : null,
      synonyms: values.synonyms,
      rules: values.rules.map((rule) => ({
        client_id: Number(rule.client_id),
        substitutions: rule.substitutions.map(
          (substitution) => substitution.id
        ),
      })),
    };

    await createProductRuleMutation.mutateAsync(payload);
  };

  return (
    <S.Container className="entry-app-content">
      <div className="content-holder">
        <div>
          <div className="wrapper-header-content">
            <PageHeader title="Criar nova regra">
              <Breadcrumb
                list={[
                  {
                    path: "/produtos/regras",
                    label: "Regras Produto",
                    current: false,
                  },
                  {
                    path: "/produtos/regras",
                    label: "Criar nova regra",
                    current: true,
                  },
                ]}
              />
            </PageHeader>
            <div className="buttons-container">
              <Button
                outlined
                borderRadius="111"
                onClick={() => history.push("/produtos")}
              >
                Cancelar
              </Button>
              <Button
                form="product-rules-form"
                type="submit"
                borderRadius="111"
                loading={createProductRuleMutation.isLoading}
              >
                Salvar
              </Button>
            </div>
          </div>
        </div>

        <main>
          <div className="form">
            <ProductRulesForm onSubmit={handleSubmit} />
          </div>
        </main>
      </div>
    </S.Container>
  );
};

export default ProductRules;
